import { IconProp } from "@fortawesome/fontawesome-svg-core"
import { IOptionProps } from "components/Form/FormOption/formoption.interface"
import TranslationData from "components/Form/FormTemplate/formtemplate.interface"

export interface IFormCardButtonProps {
  defaultValue?: any,
  t?: any
  translationData?: TranslationData
  icon?: IconProp
  id?: number
  title?: string
  description?: string
  iconColor?: string
  size?: string
  option?: IOptionProps
  handleClick?: (value: any) => void
}

export interface BoxProps {
  color: string
}

export enum themeShade {
  main = "main",
  light = "light"
}
